export function clamp(
  nombre: number,
  minimum: number,
  maximum: number
): number {
  const resultat = nombre <= minimum ? minimum : nombre;
  return resultat >= maximum ? maximum : resultat;
}
